import React from "react";
import { DataTable } from "./DataTable";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { usePurchasesModel } from "../purchasesModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { usePurchasesDetailModel } from './details/purchasesDetailModel';
import { DictCodeEnmu } from "@/types/AppDictEnums";

export const DataBox = () => {
    const { selectedRowKeys, dataSource, exportPurchases, disablePurchases } = usePurchasesModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);
    const { updateFormVal } = usePurchasesDetailModel(() => []);

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let purchasesEditKey = "4-2";
        let isFindNav = findNav(purchasesEditKey);
        if (!isFindNav) {
            addNav(purchasesEditKey, { id: selectedRowKeys[0], mode: "edit" });
            updateFormVal("edit", null);
        } else {
            globalPrompt("modal", {
                title: "采购合同跳转详情",
                type: "warning",
                text: "您还有采购合同详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(purchasesEditKey, { id: selectedRowKeys[0], mode: "edit" });
                    updateFormVal("edit", null);
                }
            })
        }
    }

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.P_AD}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => addNav("4-1", { id: "", mode: "add" })}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_ED}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_DEL}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    if (!selectedRowKeys.length) {
                        message.warning("请选择你要作废的单据");
                        return;
                    }
                    const row = dataSource.find(item => item.code === selectedRowKeys[0])
                    if (row?.status !== DictCodeEnmu.PURCHASE_INIF) return globalPrompt('message', { text: '该合同不可作废', type: 'warning' })
                    globalPrompt("modal", {
                        title: "采购合同作废",
                        text: ` `,
                        onOk: () => disablePurchases(selectedRowKeys[0]),
                    })
                }}
            >作废</Button>
        </YhAuth>
        {/* <YhAuth resCode={ResourceAuthEnum.DATA_S_EX}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => exportPurchases()}
        >导出</Button>
        {/* </YhAuth> */}
    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}